<div [innerHTML]="bannerHtmlString"></div>
